module.exports = __webpack_public_path__ + "img/fraud-3.2ac9ea4d.jpg";